// NOTE: USING INLINE STYLES BECAUSE TAILWIND CSS DOES NOT SUPPORT DYNAMIC VALUES FROM PROPS. THE FOLLOWING LINK EXPLAINS WHY:
// https://v2.tailwindcss.com/docs/just-in-time-mode#arbitrary-value-support

import { useEffect, useState } from 'react';
import { TeleprompterProps } from '../../types/Camera/TeleprompterProps';
import useChart from '../../hooks/useChart';
import { useAuth } from '../../contexts/AuthContext';
import { Chart } from '../../types/Chart/Chart';
import * as Sentry from '@sentry/browser';

export const TeleprompterText = (props: TeleprompterProps) => {
  const { currentUser } = useAuth();
  const patientId = currentUser?.uid || '';
  const chartQuery = useChart(patientId);
  const data = chartQuery.data as Chart;
  const [scriptHeight, setScriptHeight] = useState(0);

  const style = {
    fontSize: `${props.textSize}px`,
    fontWeight: 'bold',
    fontFamily: 'Arial, sans-serif',
    padding: '10px',
  };

  useEffect(() => {
    const script = document.getElementById('script-container');
    const adjustHeight = () => {
      if (script) {
        const scriptDiv = script.getBoundingClientRect();
        setScriptHeight(scriptDiv.height);
        return;
      } else {
        Sentry.captureMessage('No div containing script text yet');
        console.error('No div containing script text yet');
        adjustHeight();
      }
    };
    return adjustHeight;
  }, [props.textSize]);

  if (data) {
    return (
      <>
        <div style={style}>
          <div
            style={
              props.isScrolling
                ? {
                    position: 'absolute',
                    transition: `top ${props.speed}s`,
                    transitionTimingFunction: 'linear',
                    width: '90%',
                    top: scriptHeight ? -scriptHeight * 1.5 : -1000,
                  }
                : {
                    transition: 'top 0s',
                    top: '50%',
                  }
            }
          >
            <div id="script-container">
              <p id="script" style={{ whiteSpace: 'pre-wrap' }}>
                {data.SCRIPT_REVIEW.telePrompterScript}
              </p>
            </div>
          </div>
        </div>
      </>
    );
  }
  return <div>Loading...</div>;
};
